import filterConstants from '../constants';

const sharedGantt = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.sharedGantt,
  properties: {
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.type]: '',
    [filterConstants.PROPERTY.assignee]: '',
    [filterConstants.PROPERTY.status]: '',
    [filterConstants.PROPERTY.priority]: '',
    [filterConstants.PROPERTY.reporter]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.startDate]: '',
    [filterConstants.PROPERTY.endDate]: '',
    [filterConstants.PROPERTY.creationDate]: '',
    [filterConstants.PROPERTY.color]: '',
    [filterConstants.PROPERTY.overdue]: '',
  },
});

export default sharedGantt;
